module.exports = __webpack_public_path__ + "static/media/footer.2d4d4d3d.svg";